import { Pattern } from 'fabric';

import getFilmPattern from './getFilmPattern';

// Stopgap allow-list of the one gang-sheet customer model until products carry a gang-sheet marker.
// Must match the dashboard's libs/core/product-details/constants/product-uid-gang-sheet-reg-exp.ts.
const GANG_SHEET_PRODUCT_UID_REGEXP = /_davidsharp_dtf_/;

// Keep perceived brightness >= 50: new text and shapes take their colour from the live canvas
// under them (getVisibleColorAtElementPosition), and that colour is saved and printed.
export const NON_PRINTING_PAGE_COLOR = 'rgba(154, 154, 154, 1)';

export type PageFill = string | Pattern;

export function isGangSheetProductUid(productUid?: string): boolean {
  return !!productUid && GANG_SHEET_PRODUCT_UID_REGEXP.test(productUid);
}

// DTF film prints no background, so white artwork would vanish on a white page.
export function getNonPrintingPageFill(productUid?: string): PageFill | undefined {
  return isGangSheetProductUid(productUid) ? getFilmPattern() ?? NON_PRINTING_PAGE_COLOR : undefined;
}
